import {useEffect, useLayoutEffect, useRef, useState} from "react";

/**
 * Üç satırı birlikte otomatik sığdırır.
 * - width: 52mm sabit kutu
 * - white-space: nowrap -> satır hiç aşağı düşmez, font küçülür
 * - Hepsi aynı font-size (CSS var(--fs)) kullanır
 */
export default function AutoFitGroupLabel11({ processedData, widthMm = 52, reversible }) {
  const { partzero, parttwo, partthree } = processedData || {};
  const boxRef = useRef(null);
  const [fontSize, setFontSize] = useState(12);
  const MIN_FS = 6, MAX_FS = 12;

  const fitsAt = (sizePt) => {
    const el = boxRef.current;
    if (!el) return true;
    el.style.setProperty("--fs", `${sizePt}pt`);
    let ok = true;
    el.querySelectorAll("[data-line]").forEach((n) => {
      if (n.scrollWidth > n.clientWidth) ok = false;
    });
    return ok;
  };

  const recalc = () => {
    let lo = MIN_FS, hi = MAX_FS, best = MIN_FS;
    if (fitsAt(MAX_FS)) { setFontSize(MAX_FS); return; }
    for (let i = 0; i < 20; i++) {
      const mid = (lo + hi) / 2;
      if (fitsAt(mid)) { best = mid; lo = mid; } else { hi = mid; }
      if (hi - lo < 0.1) break;
    }
    setFontSize(Math.max(MIN_FS, Math.min(MAX_FS, Math.round(best * 10) / 10)));
  };

  useLayoutEffect(() => { recalc(); }, [partzero, parttwo, partthree]);
  useEffect(() => {
    if (!boxRef.current) return;
    const ro = new ResizeObserver(() => recalc());
    ro.observe(boxRef.current);
    window.addEventListener("resize", recalc);
    return () => { ro.disconnect(); window.removeEventListener("resize", recalc); };
  }, []);

  return (
    <div
      ref={boxRef}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "absolute",
        top: 36,
        left: 0,
        width: `${widthMm}mm`,
        ["--fs"]: `${fontSize}pt`,
      }}
    >
      {/* partzero + sağa REVERSIBLE */}
      <p className="zara-regular" data-line style={{ fontSize: "var(--fs)", whiteSpace: "nowrap", margin: 0 }}>
        {partzero}
        {reversible && <span style={{ fontSize: "var(--fs)" }}>&nbsp;REVERSIBLE</span>}
      </p>

      {/* sola REVERSIBLE + parttwo */}
      <p className="zara-regular" data-line style={{ fontSize: "var(--fs)", whiteSpace: "nowrap", marginTop: -3, marginBottom: 0 }}>
        {reversible && <span style={{ fontSize: "var(--fs)" }}>REVERSIBLE&nbsp;</span>}
        {parttwo}
      </p>

      {/* partthree + sağa REVERSIBLE */}
      <p className="zara-regular" data-line style={{ fontSize: "var(--fs)", whiteSpace: "nowrap", marginTop: -3, marginBottom: 0 }}>
        {partthree}
        {reversible && <span style={{ fontSize: "var(--fs)" }}>&nbsp;REVERSIBLE</span>}
      </p>
    </div>
  );
}
